import { combineEpics } from 'redux-observable';
import type { State, Action } from '../../state/types';
import { loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic } from './confluence-access';
import { loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic } from './confluence-space';
import { loadHasViewedPulseEpic, setHasViewedPulseEpic } from './contextual-menu-pulse';

export const loadWhiteboardsEntrypointExperimentEpic = combineEpics<Action, State>(
	loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic,
	loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic,
	loadHasViewedPulseEpic,
	setHasViewedPulseEpic,
);
